module.exports = __webpack_public_path__ + "7d088296/img/upload-icon.9179ae4e.svg";